export default __webpack_public_path__ + "static/media/pexels-monstera-6998348.79ddd439.jpg";